module.exports = __webpack_public_path__ + "doctor3.65e95ae2008328d1c3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor3.png
// module id = 453
// module chunks = 1